import Vue from 'vue'
import queryString from 'query-string'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { initShare } from '../lib/wxShare'
// import { initShare } from '../lib/tencentShare'

// 阻止 vue-router 修改页面链接
// 使用 myReplaceState 来修改页面链接，
// /src/router/index.js 需要同步修改
// history.myReplaceState = history.replaceState
// history.replaceState = function () {}

// url操作，
// @params {url|string} 要操作的链接，可以缺省，使用当前页面
// 

// 初始化分享
initShare({
  url: store.state.jsUrl,
  title: store.state.shareData.title,
  desc: store.state.shareData.desc,
  image: store.state.shareData.image
}, () => {
})

function deleteCodeInUrl () {
  const name = 'code'
  let url = ''
  var query = window.location.search.substr(1)
  if (query.indexOf(name)>-1) {
    var obj = {}
    var arr = query.split("&");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    };

    // console.log(obj)
    delete obj[name];
    url = JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");

    history.replaceState(history.state, '', location.pathname + '?' + url + location.hash)
  }
}

// 初始化vue
function initVue () {
  if (location.hostname.includes('192.168')) {
    // 开发环境，修改请求接口域名
    store.commit('setHost', {
      hostname: location.protocol + '//' + location.hostname + ':3000',
    })
  }

  // 检查有没有state，里面有没有shareid，有的话，跳转到分享页
  const search = queryString.parse(location.search)
  const state = search.state
  let shareId = ''
  if (search.shareId && search.shareId.length === 16) {
    shareId = search.shareId
  } else if (state && state.length > 0 && state.match(/^shareidis/ig) !== null) {
    shareId = search.state.replace('shareidis', '')
  }

  if (shareId) {
    store.commit('setShareId', shareId)
    router.replace('share')
  } else {
    router.replace('/')
  }

  // 删除掉url里的code
  // deleteCodeInUrl ()

  // 加载进度，80%
  document.getElementsByClassName('loading-inner')[0].style.width = '80%'

  Vue.config.productionTip = false

  // 初始化vue
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}


function wxLogin(callback){
  // 获取初始链接链接，用来校验微信验证
  store.commit('setWxShareUrl', location.href)

  // 如果是在微信里打开，要做微信授权，获取用户信息
  if (navigator.userAgent.match(/micromessenger/ig) !== null && location.hostname === 'm.china.com.cn') {
    // 中国网微信的id
    const appId = 'wx3915bce572d4c564'
    const search = queryString.parse(location.search)
    const code = search.code
    let shareId = search.shareId

    if (search.shareId && search.shareId.length === 16) {
      shareId = 'shareidis' + search.shareId
    }

    // 有缓存微信用户的数据，并且在7天以为
    if (window.localStorage && localStorage.wxUserCreateTime && new Date().getTime() - localStorage.wxUserCreateTime < 7 * 24 * 3600 * 1000) {
      store.commit('setWxUser', {
        openid: localStorage.wxUserOpenid,
        nickname: localStorage.wxUserNickname,
        headimgurl: localStorage.wxUserAvatar
      })
      
      // 完成了目标，执行后面不再执行
      return callback()
    } else if (window.localStorage) {
      // 用户的数据是7天前的，清空数据，重新获取
      localStorage.wxUserOpenid = undefined
      localStorage.wxUserNickname = undefined
      localStorage.wxUserAvatar = undefined
      localStorage.wxUserCreateTime = undefined
    } else {
      window.localStorage = {}
    }

    // 还没有微信授权
    if (code === undefined) {
      // 申请微信授权，有可能被拒绝
      var redirectUri = encodeURIComponent(location.protocol + '//' + location.host + location.pathname)
      window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=' + shareId + '#wechat_redirect')

      setTimeout(() => {
        callback()
      }, 2000)
    } else {
      deleteCodeInUrl()

      // 加载进度，60%
      document.getElementsByClassName('loading-inner')[0].style.width = '60%'

      axios.get('https://k1.m.china.com.cn/app/wx/openid?host=' + appId + '&code=' + code + '&type=userinfo')
        .then(response => {
          store.commit('setWxUser', {
            openid: response.data.userInfo.openid,
            nickname: response.data.userInfo.nickname,
            // headimgurl: 'https://share.m.china.com.cn/scanuser/image?image=' + 
            headimgurl: 'https://m.china.com.cn/thirdwx/' + response.data.userInfo.headimgurl.replace('http://thirdwx.qlogo.cn/', '')
          })

          // 缓存用户的微信信息到 localStorage 
          localStorage.wxUserOpenid = response.data.userInfo.openid
          localStorage.wxUserNickname = response.data.userInfo.nickname
          localStorage.wxUserAvatar = 'https://m.china.com.cn/thirdwx/' + response.data.userInfo.headimgurl.replace('http://thirdwx.qlogo.cn/', '')
          localStorage.wxUserCreateTime = new Date().getTime()

          // console.log(response.data.userInfo.headimgurl)

          callback()
        })
        .catch(err => {
          // alert('微信登陆失败，为获得更好的体验，请刷新页面重试')
          // console.log(err)

          callback()
        })
    }
  } else {
    callback()
  }
}


// 初始化vue
wxLogin(() => {
  initVue()
})


